module.exports = __webpack_public_path__ + "static/media/vnc.43a171c7.png";